import React from 'react';
import './FormInput.css';

const FormInput = ({ label, id, type, value, onChange, placeholder, disabled }) => {
  return (
    <div className="form-group">
      <label htmlFor={id}>{label}</label>
      <input
        type={type}
        id={id}
        className="form-control"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  );
};

export default FormInput;
